import {COUNTRY} from 'front-onceforall-core/dist/utils/country';

export const documentTypesInDb = [{
  documentTypeId: 56,
  name: 'Compte rendu commune CSPS',
  code: 'ADD_CSPS',
  parentCode: 'ADDITIONAL',
  parentName: 'Documents complémentaires',
  multiOccurrence: true,
  validityPeriod: null,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: true,
  dossier: 'PROJECT',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE'
},
{
  documentTypeId: 55,
  name: 'PPSPS Plan particulier de sécurité et de protection',
  code: 'ADD_PPSPS',
  parentCode: 'ADDITIONAL',
  parentName: 'Documents complémentaires',
  multiOccurrence: true,
  validityPeriod: null,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: true,
  dossier: 'PROJECT',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE'
},
{
  documentTypeId: 297,
  name: 'Liste du personnel Nominative',
  code: 'EMP_NOM_STAFF',
  parentCode: 'EMPLOYEES_LIST',
  parentName: 'Liste des salariés',
  multiOccurrence: false,
  validityPeriod: 6,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: true,
  dossier: 'PROJECT',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE'
},
{
  documentTypeId: 298,
  name: 'Charte RSE',
  code: 'ADD_CHARTE_RSE',
  parentCode: 'ADDITIONAL',
  parentName: 'Documents complémentaires',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: false,
  dossier: 'PROJECT',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE_BO'
},
{
  documentTypeId: 42,
  name: 'Attestation Décennale Nominative',
  code: 'INS_DEC_NOMINATIVE',
  parentCode: 'INSURANCE',
  parentName: 'Attestation d\'assurance',
  multiOccurrence: true,
  validityPeriod: null,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'ORGANISATION',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: true,
  dossier: 'PROJECT',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE_BO'
},
{
  documentTypeId: 41,
  name: 'Liste des salariés étrangers soumis à autorisation de travail',
  code: 'FOREIGN_EMPLOYEES',
  parentCode: 'EMPLOYEES_LIST',
  parentName: 'Liste des salariés',
  multiOccurrence: false,
  validityPeriod: 6,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: {
    code: 'FR_SAL',
    rule: 'UNIQUE'
  },
  canBeAdded: true,
  dossier: 'LEGAL',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 53,
  name: 'Assurance RC Professionnelle',
  code: 'INS_RC_PRO',
  parentCode: 'INSURANCE',
  parentName: 'Attestation d\'assurance',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: false,
  hasExample: true,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: true,
  equivalence: null,
  canBeAdded: true,
  dossier: 'BUSINESS',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 270,
  name: 'Attestation de Garantie Financière',
  code: 'FIN_GUARANTEE',
  parentCode: 'FINANCIAL',
  parentName: 'Document financier',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: true,
  dossier: 'BUSINESS',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 309,
  name: 'RIB opération',
  code: 'ADD_RIB_OPE',
  parentCode: 'ADDITIONAL',
  parentName: 'Documents complémentaires',
  multiOccurrence: true,
  validityPeriod: null,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: false,
  dossier: 'PROJECT',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE'
},
{
  documentTypeId: 36,
  name: 'Attestation Congés payés',
  code: 'FR_PAY',
  parentCode: 'PAID_LEAVE',
  parentName: 'Attestation Congés payés et intempéries',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: true,
  hasExample: true,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: true,
  equivalence: {
    code: 'FR_PAY',
    rule: 'MULTIPLE'
  },
  canBeAdded: true,
  dossier: 'BUSINESS',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 43,
  name: 'Attestation Décennale Standard',
  code: 'FR_INS_DEC',
  parentCode: 'INSURANCE',
  parentName: 'Attestation d\'assurance',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: true,
  hasExample: true,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: true,
  equivalence: {
    code: 'FR_INS_DEC',
    rule: 'MULTIPLE'
  },
  canBeAdded: true,
  dossier: 'BUSINESS',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 35,
  name: 'Justificatif d\'immatriculation',
  code: 'FR_REG',
  parentCode: 'REGISTRATION',
  parentName: 'Justificatif d\'immatriculation',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: true,
  hasExample: true,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: {
    code: 'FR_REG',
    rule: 'UNIQUE'
  },
  canBeAdded: true,
  dossier: 'LEGAL',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 241,
  name: 'Licence de transport',
  code: 'FR_LIC_TRANS',
  parentCode: 'TRANSPORTATION',
  parentName: 'License de transport',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: true,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: {
    code: 'FR_LIC_TRANS',
    rule: 'MULTIPLE'
  },
  canBeAdded: true,
  dossier: 'BUSINESS',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 60,
  name: 'Qualifications ou Capacités de l\'entreprise',
  code: 'FR_QUALIF_CERTIF',
  parentCode: 'EXT_CERTIF',
  parentName: 'Qualifications',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: true,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: true,
  equivalence: {
    code: 'FR_QUALIF_CERTIF',
    rule: 'MULTIPLE'
  },
  canBeAdded: true,
  dossier: 'BUSINESS',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 29,
  name: 'Attestation de vigilance',
  code: 'FR_COV',
  parentCode: 'COVERAGE',
  parentName: 'Attestation de vigilance',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: true,
  hasExample: true,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: true,
  equivalence: {
    code: 'FR_COV',
    rule: 'UNIQUE'
  },
  canBeAdded: true,
  dossier: 'LEGAL',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 250,
  name: 'Autorisation administrative d\'exercer',
  code: 'FR_AUT_ADM',
  parentCode: 'ACTIVITY_LICENCE',
  parentName: 'Autorisation administrative d\'exercer',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: true,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: {
    code: 'FR_AUT_ADM',
    rule: 'MULTIPLE'
  },
  canBeAdded: true,
  dossier: 'BUSINESS',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 48,
  name: 'Attestation fiscale',
  code: 'FR_TAX',
  parentCode: 'TAX',
  parentName: 'Attestation Fiscale',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: true,
  hasExample: true,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: true,
  equivalence: {
    code: 'FR_TAX',
    rule: 'MULTIPLE'
  },
  canBeAdded: true,
  dossier: 'BUSINESS',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 246,
  name: 'Attestation Assurance Transport',
  code: 'FR_ASSU_TRANS',
  parentCode: 'INSURANCE',
  parentName: 'Attestation d\'assurance',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: true,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: true,
  equivalence: {
    code: 'FR_ASSU_TRANS',
    rule: 'MULTIPLE'
  },
  canBeAdded: true,
  dossier: 'BUSINESS',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 272,
  name: 'Attestation Mutuelle',
  code: 'ATTES_MUT',
  parentCode: 'PENSION_HEALTH',
  parentName: 'Attestation de mutuelle / prévoyance / retraite',
  multiOccurrence: false,
  validityPeriod: 6,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: true,
  dossier: 'ADDITIONAL',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE'
},
{
  documentTypeId: 273,
  name: 'Attestation Prévoyance',
  code: 'ATTES_PREV',
  parentCode: 'PENSION_HEALTH',
  parentName: 'Attestation de mutuelle / prévoyance / retraite',
  multiOccurrence: false,
  validityPeriod: 6,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: true,
  equivalence: null,
  canBeAdded: true,
  dossier: 'ADDITIONAL',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE'
},
{
  documentTypeId: 274,
  name: 'Attestation Retraite',
  code: 'ATTES_RET',
  parentCode: 'PENSION_HEALTH',
  parentName: 'Attestation de mutuelle / prévoyance / retraite',
  multiOccurrence: false,
  validityPeriod: 6,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: true,
  equivalence: null,
  canBeAdded: true,
  dossier: 'ADDITIONAL',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE'
},
{
  documentTypeId: 275,
  name: 'Attestation Retraite',
  code: 'ATTES_RET',
  parentCode: 'PENSION_HEALTH',
  parentName: 'Attestation de mutuelle / prévoyance / retraite',
  multiOccurrence: false,
  validityPeriod: 6,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: true,
  equivalence: null,
  canBeAdded: true,
  dossier: 'ADDITIONAL',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE'
},
{
  documentTypeId: 235,
  name: 'Attestation Désignation Représentant de l\'Entreprise',
  code: 'PW_REP_ENT',
  parentCode: 'POSTED_WORK',
  parentName: 'Document de détachement',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: true,
  dossier: 'PROJECT',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 236,
  name: 'Déclaration préalable de détachement',
  code: 'PW_DEC_DETACH',
  parentCode: 'POSTED_WORK',
  parentName: 'Document de détachement',
  multiOccurrence: true,
  validityPeriod: null,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: true,
  dossier: 'PROJECT',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 237,
  name: 'Formulaire A1',
  code: 'PW_A1_FR',
  parentCode: 'POSTED_WORK',
  parentName: 'Document de détachement',
  multiOccurrence: true,
  validityPeriod: null,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: true,
  dossier: 'PROJECT',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'ALWAYS_CHECKED'
},
{
  documentTypeId: 312,
  name: 'Attestation Mutuelle Prévoyance Etranger',
  code: 'ATTES_MUT_PREV_ET',
  parentCode: 'PENSION_HEALTH',
  parentName: 'Attestation de mutuelle / prévoyance / retraite',
  multiOccurrence: false,
  validityPeriod: null,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: true,
  dossier: 'ADDITIONAL',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE'
},
{
  documentTypeId: 313,
  name: 'Attestation sur l\'honneur',
  code: 'ADD_SWORN_STAT',
  parentCode: 'ADDITIONAL',
  parentName: 'Attestation de mutuelle / prévoyance / retraite',
  multiOccurrence: false,
  validityPeriod: 6,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: {
    code: 'FR_SWORN',
    rule: 'UNIQUE'
  },
  canBeAdded: true,
  dossier: 'ADDITIONAL',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE'
},
{
  documentTypeId: 314,
  name: 'Attestation Assurance Matériel',
  code: 'INS_ASSU_MAT',
  parentCode: 'INSURANCE',
  parentName: 'Attestation d\'assurance',
  multiOccurrence: false,
  validityPeriod: 12,
  abstractType: false,
  hasExample: false,
  applicationLevel: 'GROUP',
  onlyForProjectSubcontractor: false,
  gatheredByDepositor: true,
  collectableByMandate: false,
  equivalence: null,
  canBeAdded: true,
  dossier: 'ADDITIONAL',
  country: COUNTRY.FRANCE,
  legacy: false,
  obligationConfiguration: 'CHECKABLE'
}];

export default class FakeDocumentTypeService {
  getByCountryAndProjectType(country) {
    return Promise.resolve(documentTypesInDb.filter(documentType => documentType.country === country));
  }

  getRequiredDocumentTypes() {
    const result = documentTypesInDb.map(documentType => ({
      documentTypeId: documentType.documentTypeId,
      requiredInDossierOverviewStatus: documentType.documentTypeId % 2 === 0
    })).filter((documentType, index) => index % 4 === 0);
    return Promise.resolve(result);
  }

  setRequiredDocumentTypes() {
    return Promise.resolve({});
  }

  getEquivalences() {
    return Promise.resolve(documentTypesInDb);
  }

  getCollectableByMandate() {
    return Promise.resolve(documentTypesInDb.filter(documentType => documentType.collectableByMandate));
  }

  getDocumentAddableForOrganisation() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(documentTypesInDb);
      }, 0);
    });
  }

  getBySubtypeCodes(subtypeCodes) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(documentTypesInDb
          .filter(docType => subtypeCodes.includes(docType.code)));
      }, 0);
    });
  }

  getMetadataFields() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve([]);
      }, 0);
    });
  }
}
